export default __webpack_public_path__ + "static/media/plus.a0162b51.png";